export default "__VITE_ASSET__O81tS8Xg__"